import FragmentDataType from "../enums/fragment-data-type";
import PatRecovered from "./pat-recovered";
import PatFumbleRecoveredByPositionPref from "./position-pref/pat-fumble-recovered-by-position-pref";

export default class PatNotRecovered extends PatRecovered {
    constructor(recoveredBy) {
        super();
        this.recoveredBy = recoveredBy;
        this.requiredData = [
            {
                name: "recoveredBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => true,
                displayName: "Recovered By",
                title: (team) => `Recovered By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true,
                positionPref: (play) =>
                    new PatFumbleRecoveredByPositionPref(play, this).resolve()
            }
        ];
    }
}
